import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./CSS/yper.css";
import Header from "./Header/Header";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Footer from "./Header/Footer";
import NotFound from "./Components/NotFound";
import Services from "./Pages/Services";
import CustomSoftware from "./childpages/Services/CustomSoftware";
import ERPBusiness from "./childpages/Services/ERPBusiness";
import WebApplication from "./childpages/Services/WebApplication";
import WebsiteDevelopment from "./childpages/Services/WebsiteDevelopment";
import WindowsApplication from "./childpages/Services/WindowsApplication";
import MobileApplication from "./childpages/Services/MobileApplication";
import FrontendDevelopment from "./childpages/Services/FrontendDevelopment";
import DatabaseSolutions from "./childpages/Services/DatabaseSolutions";
import CloudSolutions from "./childpages/Services/CloudSolutions";
import SoftwareMaintenance from "./childpages/Services/SoftwareMaintenance";
import DigitalMarketing from "./childpages/Services/DigitalMarketing";
import DomainHosting from "./childpages/Services/DomainHosting";
import Industries from "./Pages/Industries";
import HowWeWork from "./Pages/HowWeWork";
import Education from "./childpages/Industries/Education";
import FinanceAccounting from "./childpages/Industries/FinanceAccounting";
import Healthcare from "./childpages/Industries/Healthcare";
import Hospitality from "./childpages/Industries/Hospitality";
import LogisticsTransportation from "./childpages/Industries/LogisticsTransportation";
import Manufacturing from "./childpages/Industries/Manufacturing";
import ProfessionalServices from "./childpages/Industries/ProfessionalServices";
import RealEstate from "./childpages/Industries/RealEstate";
import RetailEcommerce from "./childpages/Industries/RetailEcommerce";
import StartupsSmallBusinesses from "./childpages/Industries/StartupsSmallBusinesses";
import AIVideoCreator from "./childpages/AI/AIVideoCreator";
import AIImageCreator from "./childpages/AI/AIImageCreator";
import AIBusinessSolutions from "./childpages/AI/AIBusinessSolutions";
import AISolutions from "./Pages/AISolutions";
import SEO from "./seo/SEO";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <SEO />
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/aboutus' element={<About />} />
        <Route path='/contactus' element={<Contact />} />
        <Route path='/services' element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/howwework" element={<HowWeWork />} />
        <Route path="/ai-solutions" element={<AISolutions />}/>

        <Route path="/services/custom-software" element={<CustomSoftware />} />
        <Route path="/services/erp-business" element={<ERPBusiness />} />
        <Route path="/services/web-application" element={<WebApplication />} />
        <Route path="/services/website-development" element={<WebsiteDevelopment />} />
        <Route path="/services/windows-application" element={<WindowsApplication />} />
        <Route path="/services/mobile-application" element={<MobileApplication />} />
        <Route path="/services/frontend-development" element={<FrontendDevelopment />} />
        <Route path="/services/database-solutions" element={<DatabaseSolutions />} />
        <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
        <Route path="/services/software-maintenance" element={<SoftwareMaintenance />} />
        <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
        <Route path="/services/domain-hosting" element={<DomainHosting />} />

        <Route path="/industries/education" element={<Education />} />
        <Route path="/industries/finance" element={<FinanceAccounting />} />
        <Route path="/industries/healthcare" element={<Healthcare />} />
        <Route path="/industries/hospitality" element={<Hospitality />} />
        <Route path="/industries/logistics" element={<LogisticsTransportation />} />
        <Route path="/industries/manufacturing" element={<Manufacturing />} />
        <Route path="/industries/professional" element={<ProfessionalServices />} />
        <Route path="/industries/realestate" element={<RealEstate />} />
        <Route path="/industries/retailecommerce" element={<RetailEcommerce />} />
        <Route path="/industries/startups" element={<StartupsSmallBusinesses />} />

        <Route path="/ai/video-creator" element={<AIVideoCreator />} />
        <Route path="/ai/image-creator" element={<AIImageCreator />} />
        <Route path="/ai/business-solutions" element={<AIBusinessSolutions />} />

        <Route path='*' element={<NotFound />} />

      </Routes>
      <Footer />
      <ToastContainer />
    </Router>
  );
}

export default App;
